import React from "react";
import styled from "styled-components";
import { FooterLinkFaq, FooterLinkPEPD } from "../../constants";

const BarContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.branding.bannerColor};
  color: ${({ theme }) => theme.branding.color};
  /* position: fixed; */
  bottom: 0;
  left: 0;
  text-align: center;
  padding: 10px;
  font-size: 0.8rem;

  /* @media (max-width: 768px) {
    padding: 15px 0;
  }

  @media (max-width: 480px) {
    padding: 20px 0;
  } */
`;

const Link = styled.a`
  color: ${({ theme }) => theme.branding.color};
`;

function BottomBar() {
  return (
    <BarContainer>
      <p>
        Need Help? Contact us at (972) 692-2780 / ¿Necesitas ayuda? Contáctanos
        al (972) 692-2780
        <br />
        <Link href={FooterLinkFaq} target="_blank" rel="noopener noreferrer">
          {" "}
          Frequently Asked Questions{" "}
        </Link>{" "}
        /{" "}
        <Link href={FooterLinkFaq} target="_blank" rel="noopener noreferrer">
          Preguntas frecuentes{" "}
        </Link>{" "}
        |{" "}
        <Link href={FooterLinkPEPD} target="_blank" rel="noopener noreferrer">
          DCHHS Public Emergency Preparedness Division
        </Link>{" "}
        /{" "}
        <Link href={FooterLinkPEPD} target="_blank" rel="noopener noreferrer">
          División de Preparación para Emergencias Públicas del DCHHS
        </Link>{" "}
      </p>
      <p>
        <b>PLEASE NOTE:</b> It may take 48 - 72 hours to receive a response from
        our staff. / <b>TENGA EN CUENTA:</b> Puede tomar entre 48 y 72 horas
        recibir una respuesta de nuestro personal.
      </p>
    </BarContainer>
  );
}

export default BottomBar;
